import { setIsMaintenanceChartVisible } from '@/store/slices/applicationSlice';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { maintenanceChartVisible, RootState } from '@/store/store';
import { setShowAlarms } from '@/store/slices/assetsPreviewSlice/alarmsSlice';

export function useDiagnosticChartLayout() {
  const [isOpen, setIsOpen] = useState(false);
  const isMaintenanceChartVisibleState = useSelector(maintenanceChartVisible);
  const { showAlarms } = useSelector((state: RootState) => state.alarms);

  const dispatch = useDispatch();
  const handleToggle = useCallback(
    (val: boolean, id: 'maintenance' | 'alarms') => {
      if (id === 'alarms') {
        dispatch(setShowAlarms(val));
      } else {
        dispatch(
          setIsMaintenanceChartVisible({
            ...isMaintenanceChartVisibleState,
            onDiagnostics: !isMaintenanceChartVisibleState.onDiagnostics,
          })
        );
      }
    },
    [isMaintenanceChartVisibleState, dispatch]
  );
  return {
    isOpen,
    showMaint: isMaintenanceChartVisibleState.onDiagnostics,
    showAlarms,
    setIsOpen,
    handleToggle,
  };
}
